"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signup = exports.signOut = exports.requestEmailVerificationCode = exports.isAuthenticated = exports.confirmEmailVerification = exports.changePassword = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
_axios.default.defaults.withCredentials = true;

/**
 * Utility function which either returns a boolean as to whether current user is authenticated.
 */
var isAuthenticated = exports.isAuthenticated = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (authEndpoint) {
    try {
      yield _axios.default.post("".concat(authEndpoint, "/me"));
      return true;
    } catch (err) {
      return false;
    }
  });
  return function isAuthenticated(_x) {
    return _ref.apply(this, arguments);
  };
}();
var signup = exports.signup = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (user, authEndpoint) {
    var {
      username,
      email,
      firstName,
      lastName,
      password
    } = user;
    try {
      var response = yield _axios.default.post("".concat(authEndpoint, "/signup"), {
        username,
        email,
        firstName,
        lastName,
        password
      });
      return response;
    } catch (err) {
      throw err.response.data;
    }
  });
  return function signup(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Signs a user out. Will throw an error if the process fails.
 */
var signOut = exports.signOut = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(function* (authEndpoint, preSignOut) {
    try {
      if (preSignOut) {
        preSignOut();
      }
      yield _axios.default.post("".concat(authEndpoint, "/signout"));
      return true;
    } catch (err) {
      return false;
    }
  });
  return function signOut(_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();
var requestEmailVerificationCode = exports.requestEmailVerificationCode = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(function* (authEndpoint) {
    try {
      yield _axios.default.post("".concat(authEndpoint, "/verify"), {
        action: 'REQUEST_CODE'
      });
      return true;
    } catch (err) {
      throw err.response.data;
    }
  });
  return function requestEmailVerificationCode(_x6) {
    return _ref4.apply(this, arguments);
  };
}();
var confirmEmailVerification = exports.confirmEmailVerification = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(function* (code, authEndpoint) {
    try {
      yield _axios.default.post("".concat(authEndpoint, "/verify"), {
        action: 'SUBMIT',
        code
      });
      return true;
    } catch (err) {
      throw err.response.data;
    }
  });
  return function confirmEmailVerification(_x7, _x8) {
    return _ref5.apply(this, arguments);
  };
}();
var changePassword = exports.changePassword = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(function* (currentPassword, newPassword, authEndpoint) {
    try {
      yield _axios.default.post("".concat(authEndpoint, "/manage-password"), {
        action: 'CHANGE',
        currentPassword,
        newPassword
      });
      return true;
    } catch (err) {
      throw err.response.data;
    }
  });
  return function changePassword(_x9, _x10, _x11) {
    return _ref6.apply(this, arguments);
  };
}();